import * as React from "react";
import { useState } from "react";
import { Notification } from "react-admin";
import { ThemeProvider } from "@material-ui/styles";
import { createTheme } from "@material-ui/core/styles";

import { ArrowBack } from "@material-ui/icons";
import RTL from "./RTL";
import { theme } from "./theme/theme";
import labelsTranslation from "./translations/tranlation";
import "./login.scss";

import { LoginWithOTP } from "./Components/Login/LoginWithOTP";
import { LoginWithUserPass } from "./Components/Login/LoginWithUserPass";
import athleteBGImage from "./assets/background-image-login-athlete.jpeg";
import doctorBGImage from "./assets/background-image-login-doctor.jpg";
const CLASS_NAME = "login-page";

const Login = () => {
	const [showOTP, setshowOTP] = useState(false);
	const [loginMethod, setLoginMethod] = useState<LOGIN_METHOD_TYPES>("OTP");

	const changeLoginMethod = () => {
		if (loginMethod === "OTP") {
			setLoginMethod("USERPASS");
		} else if (loginMethod === "USERPASS") {
			setLoginMethod("OTP");
		}
	};

	const onBackToMobile = () => {
		setshowOTP(false);
	};

	type LOGIN_METHOD_TYPES = "OTP" | "USERPASS";

	const renderMethod = (LOGIN_METHOD: LOGIN_METHOD_TYPES) => {
		switch (LOGIN_METHOD) {
			case "OTP":
				return <LoginWithOTP showOTP={showOTP} setShowOTP={setshowOTP} />;

			case "USERPASS":
				return <LoginWithUserPass />;

			default:
				return null;
		}
	};

	return (
		<ThemeProvider theme={createTheme(theme)}>
			<RTL>
				<div
					className={`${CLASS_NAME}`}
					style={{
						backgroundImage:
							process.env.REACT_APP_TRANSLATION_ROLE === "doctor"
								? `url(${doctorBGImage})`
								: `url(${athleteBGImage})`,
					}}
				>
					<div className={`${CLASS_NAME}__wrapper`}>
						<div className={`${CLASS_NAME}__box`}>
							{showOTP && (
								<div
									className=""
									style={{
										width: "100%",
										display: "flex",
										justifyContent: "flex-end",
									}}
								>
									<span
										style={{
											display: "flex",
											alignItems: "center",
											gap: "4px",
											fontSize: ".7rem",
											cursor: "pointer",
											color: "black",
										}}
										onClick={onBackToMobile}
									>
										<span>تغییر شماره موبایل</span>
										<ArrowBack style={{ fontSize: "1rem" }} />
									</span>
								</div>
							)}
							<h2>
								<span>پنل</span>
								<span>&nbsp;</span>
								<span>{labelsTranslation.login.panelName}</span>
							</h2>
							{renderMethod(loginMethod)}
							<div
								style={{
									// border: "1px solid black",
									width: "100%",
									boxSizing: "border-box",
									padding: "0 1rem",
								}}
							>
								<fieldset>
									<legend>یا</legend>
								</fieldset>
								<p
									className="change-login-method"
									onClick={changeLoginMethod}
									style={{
										cursor: "pointer",
										width: "100%",
										// textAlign: "right",
										borderRadius: "8px",
										padding: ".5rem 0",
									}}
								>
									{loginMethod === "OTP"
										? "ورود با نام کاربری و رمز عبور"
										: "ورود با شماره موبایل و رمز یکبار مصرف"}
								</p>
							</div>
						</div>
						<Notification />
					</div>
				</div>
			</RTL>
		</ThemeProvider>
	);
};

export default Login;
